<template>
  <q-page class="q-pa-md">
    <app-state
      v-if="status !== 'ready' && status !== 'loading'"
      :state="status"
      :title="status === 'not-found' ? 'Операция не найдена' : 'Не удалось загрузить операцию'"
      :message="errorMessage"
      action-label="Вернуться к документам"
      :action-to="{ name: 'documents_list' }"
    />

    <div v-else-if="status === 'loading'" class="operation-state" data-route-state="loading">
      <q-spinner color="primary" size="40px" />
      <div class="text-h6 q-mt-md">Загружаем операцию</div>
    </div>

    <div v-else data-route-state="ready">
      <div class="row items-start justify-between q-gutter-md q-mb-lg">
        <div>
          <h1 class="text-h5 q-my-none">{{ document.name || `Операция №${document.id}` }}</h1>
          <div class="text-body2 text-grey-7 q-mt-xs">{{ document.date_display || 'Дата не указана' }}</div>
        </div>
        <q-btn
          outline
          color="primary"
          no-caps
          label="Открыть исходный документ"
          :to="documentRoute"
        />
      </div>

      <q-card flat bordered>
        <q-card-section>
          <div class="text-subtitle1">Сведения об операции</div>
        </q-card-section>
        <q-separator />
        <q-list separator>
          <q-item>
            <q-item-section>
              <q-item-label caption>Тип документа</q-item-label>
              <q-item-label>{{ documentTypeLabel }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label caption>Статус</q-item-label>
              <q-item-label>{{ document.is_active === false ? 'Не проведен' : 'Проведен' }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label caption>Количество проводок</q-item-label>
              <q-item-label>{{ document.transfers.length }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card>
    </div>
  </q-page>
</template>

<script>
import AppState from '../../../components/ui/AppState.vue'

const DOCUMENT_INFO_ROUTES = {
  upd: 'document_info_upd',
  payment: 'document_info_payment',
  factura_avance: 'document_info_factura_avance',
  bill_to_pay: 'document_info_bill_to_pay',
  act_sver: 'document_info_act_sver'
}

const DOCUMENT_TYPE_LABELS = {
  upd: 'УПД',
  payment: 'Платежное поручение',
  factura_avance: 'Счет-фактура на аванс',
  bill_to_pay: 'Счет на оплату',
  act_sver: 'Акт сверки'
}

export default {
  name: 'operation_info',
  components: { AppState },
  data() {
    return {
      status: 'loading',
      errorMessage: '',
      document: {
        id: this.$route.params.id,
        name: '',
        date_display: '',
        document_type: '',
        is_active: false,
        transfers: []
      }
    }
  },
  computed: {
    documentTypeLabel() {
      return DOCUMENT_TYPE_LABELS[this.document.document_type] || 'Документ'
    },
    documentRoute() {
      const name = DOCUMENT_INFO_ROUTES[this.document.document_type]
      return name
        ? { name, params: { id: this.document.id } }
        : { name: 'documents_list' }
    }
  },
  created() {
    this.emitter.on('didReceiveDocumentInfo', this.onDocumentLoaded)
    this.emitter.on('onDocumentInfoError', this.onDocumentError)
    this.requestDocument()
  },
  beforeUnmount() {
    this.emitter.off('didReceiveDocumentInfo', this.onDocumentLoaded)
    this.emitter.off('onDocumentInfoError', this.onDocumentError)
  },
  methods: {
    requestDocument() {
      const load = () => this.connection.getDocumentInfo(
        `operation-info-${this.$route.params.id}`,
        this.$route.params.id,
        'last'
      )
      if (this.connection.isAuthenticated) load()
      else this.emitter.on('connectionReady', load)
    },
    onDocumentLoaded(response) {
      const data = response.data
      if (String(data.id) !== String(this.$route.params.id)) return
      this.document = {
        ...data,
        transfers: Array.isArray(data.transfers) ? data.transfers : []
      }
      this.status = 'ready'
    },
    onDocumentError(error) {
      this.status = error.state || 'error'
      this.errorMessage = error.message || 'Попробуйте вернуться к списку документов'
    }
  }
}
</script>

<style scoped>
.operation-state {
  display: flex;
  min-height: 320px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
